import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        meta: { requiresAdmin: true },
      },
      {
        name: 'dashboard2',
        path: 'dashboard2',
        component: () => import('../pages/admin/dashboard/Dashboard2.vue'),
      },
      {
        path: '/monitoring-data',
        name: 'MonitoringData',
        component: () => import('../pages/admin/pages/MonitoringData.vue'),
        meta: { requiresAdmin: true },
      },
      {
        path: '/literature-search',
        name: 'LiteratureSearch',
        component: () => import('../pages/admin/pages/LiteratureSearch.vue'),
      },
      {
        path: '/news-search',
        name: 'InternationalNews',
        component: () => import('../pages/admin/pages/InternationalNews.vue'),
      },
      {
        path: '/virus-sequence',
        name: 'VirusSequence',
        component: () => import('../pages/admin/pages/VirusSequence.vue'),
        meta: { requiresAdmin: true },
      },
      {
        path: '/audio-to-text',
        name: 'AudioToText',
        component: () => import('../pages/admin/pages/AudioToText.vue'),
        // meta: { requiresAdmin: true }
      },

      {
        path: '/literature-search-result',
        name: 'LiteratureSearchResult',
        component: () => import('../pages/admin/pages/LiteratureSearchResult.vue'),
      },
      {
        path: '/news-search-result',
        name: 'NewsSearchResult',
        component: () => import('../pages/admin/pages/NewsSearchResult.vue'),
      },
      {
        path: '/global-outbreak',
        name: 'global-outbreak',
        component: () => import('../pages/admin/pages/GlobalOutbreak.vue'),
      },
      {
        path: '/weekly-report',
        name: 'weekly-report',
        component: () => import('../pages/admin/pages/WeeklyReport.vue'),
        props: true,
      },
      {
        path: '/chat',
        name: 'chat',
        component: () => import('../pages/admin/pages/Chat.vue'),
        props: true,
      },
      {
        path: '/disease-weekly-report',
        name: 'disease-weekly-report',
        component: () => import('../pages/admin/pages/DiseaseWeeklyReport.vue'),
        props: true,
      },
      {
        path: '/image',
        name: 'image',
        component: () => import('../pages/admin/pages/MakeImageView.vue'),
        props: true,
      },
      {
        path: '/news-search-test',
        name: 'test-new',
        component: () => import('../pages/admin/pages/InternationalNews-test.vue'),
      },
      {
        path: '/news-search-result-test',
        name: 'NewsSearchResult-test',
        component: () => import('../pages/admin/pages/NewsSearchResult-test.vue'),
      },
      {
        path: '/chat-test',
        name: 'chat-test',
        component: () => import('../pages/admin/pages/Chat-test.vue'),
        props: true,
      },
      {
        path: '/global-outbreak-test',
        name: 'global-outbreak-test',
        component: () => import('../pages/admin/pages/GlobalOutbreak-test.vue'),
      },
      {
        path: '/weekly-report-test',
        name: 'weekly-report-test',
        component: () => import('../pages/admin/pages/WeeklyReport-test.vue'),
        props: true,
      },
      {
        path: '/disease-weekly-report-test',
        name: 'disease-weekly-report-test',
        component: () => import('../pages/admin/pages/DiseaseWeeklyReport-test.vue'),
        props: true,
      },
      {
        path: '/literature-search-test',
        name: 'LiteratureSearch-test',
        component: () => import('../pages/admin/pages/LiteratureSearch-test.vue'),
      },
      {
        path: '/literature-search-result-test',
        name: 'LiteratureSearchResult-test',
        component: () => import('../pages/admin/pages/LiteratureSearchResult-test.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },

      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('loggedIn') === 'true'
  const isAdmin = localStorage.getItem('admin') === 'yes'

  if (to.name !== 'login' && !isLoggedIn) {
    next({ name: 'login' })
  } else if (to.meta.requiresAdmin && !isAdmin) {
    next({ name: 'dashboard2' })
  } else {
    next()
  }
})

export default router
